import { render, staticRenderFns } from "./CenarioCorpoRemetente.vue?vue&type=template&id=6f5cf348&scoped=true&"
import script from "./CenarioCorpoRemetente.vue?vue&type=script&lang=js&"
export * from "./CenarioCorpoRemetente.vue?vue&type=script&lang=js&"
import style0 from "./CenarioCorpoRemetente.vue?vue&type=style&index=0&id=6f5cf348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5cf348",
  null
  
)

export default component.exports